import { Tooltip } from '../tooltip/tooltip.tsx'
import { Icon } from '../icon/icon.tsx'

type FormFieldInfoTooltipProps = { content: string }

const FormFieldInfoTooltip = ({ content }: FormFieldInfoTooltipProps) => (
  <Tooltip content={content} variant="info">
    <Icon
      className="self-center"
      name="InformationCircleIcon"
      size="sm"
      fill="solid"
      color="info"
    />
  </Tooltip>
)

export { FormFieldInfoTooltip }
